import { useEffect } from "react";
import {
  useSharedValue,
  useAnimatedStyle,
  withRepeat,
  withTiming,
  interpolateColor,
} from "react-native-reanimated";
import { theme } from "@theme";

/**
 * Hook for creating a flashing border animation
 * @param enableBorderFlashing - Whether the border should flash
 * @returns An animated style object to apply to the border, or undefined if no animation
 */
export const useFlashingBorder = (
  enableBorderFlashing: boolean,
  selected?: boolean,
) => {
  // Animation value that oscillates between 0 and 1
  const animationProgress = useSharedValue(0);
  const isSelected = useSharedValue(selected ? 1 : 0);

  useEffect(() => {
    isSelected.value = selected ? 1 : 0;
  }, [selected]);

  useEffect(() => {
    if (enableBorderFlashing) {
      animationProgress.value = withRepeat(
        withTiming(1, { duration: 800 }),
        -1,
        true,
      );
    } else {
      animationProgress.value = withTiming(0, { duration: 200 });
    }
  }, [enableBorderFlashing]);

  const animatedBorderStyle = useAnimatedStyle(() => {
    if (isSelected.value === 1) {
      return { borderColor: theme.colors.white };
    }

    const borderColor = interpolateColor(
      animationProgress.value,
      [0, 1],
      [theme.colors.whiteTranslucent20, theme.colors.white],
    );

    return { borderColor };
  });

  return animatedBorderStyle;
};
